import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { crearSocio, obtenerSocio, actualizarSocio } from "../../services/sociosService";
import "./Socios.css";
import notify from "../common/notify";

const empty = { nombre: "", apellidos: "", telefono: "", email: "", direccion: "", notas: "", activo: true };

const SocioForm = ({ edit = false }) => {
  const { socioId } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(empty);
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(edit);

  useEffect(() => {
    if (!edit || !socioId) return;
    (async () => {
      try {
        const socio = await obtenerSocio(socioId);
        if (!socio) throw new Error("Socio no encontrado");
        setForm({ ...empty, ...socio, activo: socio.activo !== false });
      } catch (e) {
        notify.error(e.message || "No se pudo cargar el socio");
        navigate("/app/socios");
      } finally {
        setLoading(false);
      }
    })();
  }, [edit, socioId, navigate]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nombre.trim()) { notify.error("El nombre del socio es obligatorio"); return; }
    setSaving(true);
    try {
      if (edit) {
        await actualizarSocio(socioId, form);
        navigate(`/app/socios/${socioId}`);
      } else {
        const ref = await crearSocio(form);
        navigate(`/app/socios/${ref.id}`);
      }
    } catch (err) {
      console.error(err);
      notify.error("No se pudo guardar el socio: " + (err?.message || err));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="socios-page"><div className="socios-card">Cargando…</div></div>;

  return (
    <div className="socios-page">
      <form className="socios-card" onSubmit={submit}>
        <h2 className="socios-title">{edit ? "Editar socio" : "Nuevo socio"}</h2>
        <div className="socios-grid">
          <label className="socios-field"><span className="socios-label">Nombre *</span><input className="socios-input" value={form.nombre} onChange={(e) => set("nombre", e.target.value)} /></label>
          <label className="socios-field"><span className="socios-label">Apellidos</span><input className="socios-input" value={form.apellidos} onChange={(e) => set("apellidos", e.target.value)} /></label>
          <label className="socios-field"><span className="socios-label">Teléfono</span><input className="socios-input" value={form.telefono} onChange={(e) => set("telefono", e.target.value)} /></label>
          <label className="socios-field"><span className="socios-label">Correo</span><input className="socios-input" value={form.email} onChange={(e) => set("email", e.target.value)} /></label>
          <label className="socios-field wide"><span className="socios-label">Dirección</span><input className="socios-input" value={form.direccion} onChange={(e) => set("direccion", e.target.value)} /></label>
          <label className="socios-field wide"><span className="socios-label">Notas</span><textarea className="socios-textarea" value={form.notas} onChange={(e) => set("notas", e.target.value)} /></label>
          <label className="socios-field"><span className="socios-label">Estado</span><select className="socios-select" value={form.activo ? "activo" : "inactivo"} onChange={(e) => set("activo", e.target.value === "activo")}><option value="activo">Activo</option><option value="inactivo">Inactivo</option></select></label>
        </div>
        <div className="socios-actions" style={{ marginTop: 16 }}>
          <button type="button" className="socios-btn secondary" onClick={() => navigate(-1)}>Cancelar</button>
          <button className="socios-btn" disabled={saving}>{saving ? "Guardando…" : "Guardar socio"}</button>
        </div>
      </form>
    </div>
  );
};

export default SocioForm;
